var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-popover",
        {
          ref: "popoverRef",
          attrs: { placement: "bottom", width: "660", trigger: "click" },
        },
        [
          _c(
            "div",
            {
              attrs: { slot: "reference" },
              on: {
                click: function ($event) {
                  return _vm.getList()
                },
              },
              slot: "reference",
            },
            [
              _c("vab-icon", { attrs: { icon: "arrow-up-down-line" } }),
              _c("span", { staticStyle: { cursor: "pointer" } }, [
                _vm._v("标签同步"),
              ]),
              _vm.headertTotal > 0
                ? _c("el-badge", {
                    attrs: {
                      value:
                        _vm.headertTotal > 99 ? 99 + "+" : _vm.headertTotal,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "footer" },
            [
              _c("el-button", {
                attrs: { size: "mini", circle: "", icon: "el-icon-refresh" },
                on: {
                  click: function ($event) {
                    return _vm.getList()
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { height: "484px", overflow: "auto" } },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.tableLoading,
                      expression: "tableLoading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: {
                    "element-loading-text": "拼命加载中",
                    "element-loading-spinner": "el-icon-loading",
                    "element-loading-background": "rgba(0, 0, 0, 0.4)",
                    data: _vm.tableData,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "createTime",
                      label: "同步时间",
                      width: "160",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "fileName",
                      label: "同步至企业微信",
                      width: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                " 同步" +
                                  _vm._s(scope.row.totalCount) +
                                  "个" +
                                  _vm._s(scope.row.taskName) +
                                  " "
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "同步状态", width: "180" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.taskStatus == 0
                              ? _c(
                                  "span",
                                  { staticStyle: { color: "#58d44d" } },
                                  [_vm._v(" 同步中... ")]
                                )
                              : _vm._e(),
                            scope.row.taskStatus == 1 &&
                            scope.row.failCount == 0
                              ? _c("span", [_vm._v(" 同步完成 ")])
                              : _vm._e(),
                            scope.row.taskStatus == 1 &&
                            scope.row.failCount != 0
                              ? _c("span", [
                                  _vm._v(" 同步完成：失败 "),
                                  _c("span", { staticClass: "red" }, [
                                    _vm._v(_vm._s(scope.row.failCount)),
                                  ]),
                                  _vm._v(" 个 "),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "50" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.taskStatus == 1 && scope.row.failCount > 0
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleUpdata(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v(" 重推 ")]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("el-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total > 0",
              },
            ],
            staticClass: "mt10 mb10",
            staticStyle: { "text-align": "right" },
            attrs: {
              background: "",
              "page-sizes": [10, 20, 30, 50],
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
              "pager-count": 5,
              size: _vm.queryParams.pageSize,
              "current-page": _vm.queryParams.pageNum,
              "auto-scroll": false,
            },
            on: {
              "current-change": _vm.handlePageChange,
              "size-change": _vm.handleSizeChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }